import React, {useEffect} from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { detailProducts } from '../actions/productActions';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProductDetail from '../components/ProductBidding/ProductDetail';
import BidSection from '../components/ProductBidding/BidSection';
import { productBids } from '../actions/bidActions';
import { productDetailsReset } from '../reducers/productReducers';
import { logout } from '../actions/userActions';

function ProductScreen() {
    const { productParams } = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const {
        productReducers: { productDetailsError, productDetailsLoading },
    } = useSelector((state) => state)

    // Extract the productId
    const splitParams = productParams ? productParams.split('-p-') : [""];
    const id = splitParams.length > 1 ? splitParams[1] : "";

    useEffect(() => {
        dispatch(detailProducts(id));
        return () => {
            dispatch(productDetailsReset());
        }
    }, [dispatch, id]);

    // Handle authentication error
    useEffect(() => {
        if (productDetailsError && productDetailsError.includes('Authentication credentials were not provided')) {
            // Log out the user and redirect to home page
            dispatch(logout());
            navigate('/');
        }
    }, [productDetailsError, dispatch, navigate]);

    useEffect(() => {
        if (id) {
            dispatch(productBids(id))
        }
    }, [id, dispatch])

    if (!id) {
        return <Message variant='danger'>Invalid product URL</Message>
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
            {productDetailsLoading ? <Loader />
                : productDetailsError && !productDetailsError.includes('Authentication credentials were not provided') ?
                    <Message variant='danger'>{productDetailsError}</Message>
                    :
                    <Row className='my-5 justify-content-end'>
                        <ProductDetail />
                        <BidSection dispatch={dispatch} productID={id} />
                    </Row>
            }
        </>
    )
}

export default ProductScreen
